module.exports = __webpack_public_path__ + "static/media/2.02ac2f51.jpg";